(function () {
  "use strict";

  var syncTimer = null;
  var syncInProgress = false;
  var syncQueued = false;
  var shownEvenError = false;
  var transactionInProgress = false;
  var queuedTransaction = null;
  var cartUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_url) || "/cart";
  var cartUpdateUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_update_url) ||
    "/cart/update";
  var cartChangeUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_change_url) ||
    "/cart/change";

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    if (!Number.isFinite(parsed)) return fallback;
    return parsed;
  }

  function getProp(item, key) {
    if (!item || !item.properties) return "";
    return item.properties[key] || "";
  }

  function isAddonItem(item) {
    if (getProp(item, "_Door Add-On") === "Yes") return true;
    // Exos 2026-10-18: a door stop half piece is always an add-on, so one without its door stop is removed.
    if (String((item && item.handle) || "").indexOf("door-stop-half-piece") === 0) return true;

    // Defensive fallback for legacy/misaligned builder add-on lines.
    var productTitle = String(item && (item.product_title || item.title) || "").trim();
    return productTitle.indexOf("Door Builder -") === 0;
  }

  function getDoorId(item) {
    return String(
      getProp(item, "_door_id") || getProp(item, "_Door Config ID") || ""
    ).trim();
  }

  function getAddonParentId(item) {
    return String(
      getProp(item, "_parent_door_id") || getProp(item, "_Door Config ID") || ""
    ).trim();
  }

  function isDoorMainItem(item) {
    if (!item || isAddonItem(item)) return false;
    var hasConfigMarker = getProp(item, "_Door Main Item") === "Yes";
    var hasAddonPath = Boolean(getProp(item, "Add-On Path"));
    return hasConfigMarker || hasAddonPath;
  }

  function getMainMultiplier(item) {
    var explicitMultiplier = Math.max(
      toNumber(getProp(item, "_Door Main Multiplier"), 1),
      1
    );

    if (getProp(item, "_Door Main Multiplier")) {
      return explicitMultiplier;
    }

    return isDoubleDoorMainItem(item) ? 2 : 1;
  }

  function isDoubleDoorMainItem(item) {
    if (!isDoorMainItem(item)) return false;
    return String(getProp(item, "Swing")).trim() === "Double Door";
  }

  function getLegacyConfigIds(cart) {
    var legacyMainCount = 0;

    cart.items.forEach(function (item) {
      if (!isDoorMainItem(item)) return;
      if (getDoorId(item)) return;
      legacyMainCount += 1;
    });

    if (legacyMainCount === 1) {
      return ["legacy-door-config-1"];
    }

    return [];
  }

  function resolveMainConfigId(item, fallbackIds) {
    var configId = getDoorId(item);
    if (configId) return configId;

    if (fallbackIds.length === 1 && isDoorMainItem(item)) {
      return fallbackIds[0];
    }

    return "";
  }

  function resolveAddonConfigId(item) {
    // Failsafe behavior: add-ons must explicitly reference a parent ID.
    // We intentionally avoid single-parent fallback inference here because
    // it can keep true orphan lines alive when metadata is broken.
    return getAddonParentId(item);
  }

  function showEvenQuantityError() {
    if (shownEvenError) return;

    var errors = document.querySelector("[data-cart-errors]");
    var errorMessage = document.querySelector("[data-error-message]");
    if (errors && errorMessage) {
      errorMessage.textContent =
        "A Double Door has been selected. Please ensure your door quantity is an even number.";
      errors.classList.add("is-expanded");
    }

    shownEvenError = true;
  }

  function clearEvenQuantityError() {
    if (!shownEvenError) return;

    var errors = document.querySelector("[data-cart-errors]");
    var errorMessage = document.querySelector("[data-error-message]");
    if (errors && errorMessage) {
      var text = (errorMessage.textContent || "").trim();
      if (
        text ===
        "A Double Door has been selected. Please ensure your door quantity is an even number."
      ) {
        errors.classList.remove("is-expanded");
        errorMessage.textContent = "";
      }
    }

    shownEvenError = false;
  }

  function isDoorMainLineElement(itemEl) {
    if (!itemEl) return false;
    if (itemEl.getAttribute("data-door-addon-item") === "true") return false;

    var configId = String(itemEl.getAttribute("data-door-config-id") || "").trim();
    if (configId) return true;

    var detailsNode = itemEl.querySelector(".cart__item__meta");
    var detailsText = detailsNode ? String(detailsNode.textContent || "") : "";
    return detailsText.indexOf("Add-On Path:") !== -1;
  }

  function getActiveCartElement() {
    return (
      document.querySelector("cart-element[data-cart-page]") ||
      document.querySelector("cart-element")
    );
  }

  function setCartLoadingState(active, currentItem) {
    var cartElement = getActiveCartElement();

    if (currentItem) {
      if (active) {
        currentItem.classList.add("is-loading");
      } else {
        currentItem.classList.remove("is-loading");
      }
    }

    if (!cartElement) return;

    if (active) {
      if (typeof cartElement.disableCartButtons === "function") {
        cartElement.disableCartButtons();
      }
      if (typeof cartElement.addLoadingClass === "function") {
        cartElement.addLoadingClass();
      }
      return;
    }

    if (typeof cartElement.enableCartButtons === "function") {
      cartElement.enableCartButtons();
    }
    if (typeof cartElement.removeLoadingClass === "function") {
      cartElement.removeLoadingClass();
    }
  }

  function updateLineQuantity(lineKey, quantity) {
    var updateUrl = /\.js$/.test(cartChangeUrl) ? cartChangeUrl : cartChangeUrl + ".js";

    return fetch(updateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Line update failed.");
      return response.json();
    });
  }

  function handleCartQuantityGuard(event) {
    var detail = event.detail || {};
    if (!detail || typeof detail.quantity === "undefined") return;

    var itemEl = event.target && event.target.closest
      ? event.target.closest("[data-cart-item]")
      : null;

    if (!itemEl) return;

    var isDoorMainLine = isDoorMainLineElement(itemEl);
    var isDoubleDoorLine = itemEl.getAttribute("data-door-double-main") === "true";

    if (isDoubleDoorLine) {
      var requestedQtyForRule = Math.round(toNumber(detail.quantity, 0));
      if (requestedQtyForRule > 0 && requestedQtyForRule % 2 !== 0) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }

        var field = itemEl.querySelector("[data-quantity-field]");
        if (field) {
          var previousQty = Math.round(toNumber(field.getAttribute("value"), 1));
          field.value = previousQty;

          var quantityText = itemEl.querySelector("[data-quantity-select]");
          if (quantityText) {
            quantityText.textContent = String(previousQty);
          }
        }

        showEvenQuantityError();
        return;
      }

      clearEvenQuantityError();
    }

    if (!isDoorMainLine) return;

    // Intercept native cart render path for door-main quantity changes.
    // We run main update + add-on sync first, then render once from final cart state.
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    var requestedQty = Math.max(Math.round(toNumber(detail.quantity, 0)), 0);
    var request = {
      lineKey: String(detail.id || ""),
      quantity: requestedQty,
      itemEl: itemEl
    };

    if (!request.lineKey) return;

    if (transactionInProgress) {
      queuedTransaction = request;
      return;
    }

    runQuantitySyncTransaction(request);
  }

  function handleCartRemoveClick(event) {
    if (!event.target || !event.target.closest) return;

    var removeLink = event.target.closest("[data-item-remove]");
    if (!removeLink) return;

    var itemEl = removeLink.closest("[data-cart-item]");
    if (!itemEl) return;

    // Keep native remove behavior for non-door-builder lines.
    if (!isDoorMainLineElement(itemEl)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    var lineKey = String(removeLink.getAttribute("data-id") || itemEl.getAttribute("data-item") || "").trim();
    if (!lineKey) return;

    var request = {
      lineKey: lineKey,
      quantity: 0,
      itemEl: itemEl
    };

    if (transactionInProgress) {
      queuedTransaction = request;
      return;
    }

    runQuantitySyncTransaction(request);
  }

  function runQuantitySyncTransaction(request) {
    if (!request || !request.lineKey) return;
    transactionInProgress = true;
    setCartLoadingState(true, request.itemEl);

    updateLineQuantity(request.lineKey, request.quantity)
      .then(function () {
        return fetchCart();
      })
      .then(function (cartAfterMainUpdate) {
        if (!cartAfterMainUpdate || !Array.isArray(cartAfterMainUpdate.items)) return null;
        var addonUpdates = computeUpdates(cartAfterMainUpdate);
        if (Object.keys(addonUpdates).length === 0) {
          return cartAfterMainUpdate;
        }

        return updateCart(addonUpdates).then(function () {
          return fetchCart();
        });
      })
      .then(function () {
        refreshCartUI();
      })
      .catch(function () {
        // Surface the failure and re-render from the server's cart so the
        // stepper never keeps showing a change that didn't go through.
        var errors = document.querySelector("[data-cart-errors]");
        var errorMessage = document.querySelector("[data-error-message]");
        if (errors && errorMessage) {
          errorMessage.textContent =
            "That change didn't go through. Please try again.";
          errors.classList.add("is-expanded");
        }
        setCartLoadingState(false, request.itemEl);
        refreshCartUI();
      })
      .finally(function () {
        transactionInProgress = false;
        if (queuedTransaction) {
          var nextRequest = queuedTransaction;
          queuedTransaction = null;
          runQuantitySyncTransaction(nextRequest);
        }
      });
  }

  function scheduleSync() {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(runSync, 180);
  }

  function computeUpdates(cart) {
    var configBaseQty = {};
    var updates = {};
    var fixedSeen = {};
    var fallbackIds = getLegacyConfigIds(cart);
    var knownIds = [];

    cart.items.forEach(function (item) {
      if (!isDoorMainItem(item)) return;

      var configId = resolveMainConfigId(item, fallbackIds);
      if (!configId) return;
      if (knownIds.indexOf(configId) === -1) knownIds.push(configId);

      var mainMultiplier = getMainMultiplier(item);

      configBaseQty[configId] = Math.max(Math.round(item.quantity / mainMultiplier), 0);
    });

    cart.items.forEach(function (item) {
      if (!isAddonItem(item)) return;

      var configId = resolveAddonConfigId(item);
      if (!configId || knownIds.indexOf(configId) === -1) {
        if (item.quantity !== 0) {
          updates[item.key] = 0;
        }
        return;
      }

      var baseQty = configBaseQty[configId] || 0;
      // Exos 2026-10-18: fixed-qty add-ons (door stop half piece) stay at that qty while their main line exists,
      // one per group; every other add-on scales with the main line exactly as before.
      var fixedQty = Math.round(toNumber(getProp(item, "_Door Add-On Fixed Qty"), 0));
      var expectedQty;
      if (fixedQty > 0) {
        expectedQty = baseQty > 0 && !fixedSeen[configId] ? fixedQty : 0;
        fixedSeen[configId] = true;
      } else {
        var addonMultiplier = Math.max(
          toNumber(getProp(item, "_Door Add-On Multiplier"), 1),
          1
        );

        expectedQty = Math.max(Math.round(baseQty * addonMultiplier), 0);
      }
      if (item.quantity !== expectedQty) {
        updates[item.key] = expectedQty;
      }
    });

    return updates;
  }

  function fetchCart() {
    var cartJsUrl = /\.js$/.test(cartUrl) ? cartUrl : cartUrl + ".js";

    return fetch(cartJsUrl, {
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart fetch failed.");
      return response.json();
    });
  }

  function updateCart(updates) {
    var updateUrl = /\.js$/.test(cartUpdateUrl) ? cartUpdateUrl : cartUpdateUrl + ".js";

    return fetch(updateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart update failed.");
      return response.json();
    });
  }

  function refreshCartUI() {
    var cartPageElement = document.querySelector("cart-element[data-cart-page]");
    if (cartPageElement) {
      if (typeof cartPageElement.getCart === "function") {
        cartPageElement.getCart();
        return;
      }

      window.setTimeout(function () {
        if (typeof cartPageElement.getCart === "function") {
          cartPageElement.getCart();
        }
      }, 120);
      return;
    }

    // Cart drawer listens to this event and re-renders from latest cart state.
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
  }

  function runSync() {
    if (transactionInProgress) return;
    if (syncInProgress) {
      syncQueued = true;
      return;
    }

    syncInProgress = true;

    fetchCart()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return null;
        var updates = computeUpdates(cart);
        if (Object.keys(updates).length === 0) return null;
        return updateCart(updates);
      })
      .then(function (result) {
        if (!result) return;
        refreshCartUI();
      })
      .catch(function () {
        // Swallow non-critical sync errors to avoid interrupting native cart flow.
      })
      .finally(function () {
        syncInProgress = false;
        if (syncQueued) {
          syncQueued = false;
          scheduleSync();
        }
      });
  }

  document.addEventListener("DOMContentLoaded", scheduleSync);
  document.addEventListener("theme:cart:update", handleCartQuantityGuard, true);
  document.addEventListener("click", handleCartRemoveClick, true);
  document.addEventListener("theme:cart:update", scheduleSync);
  document.addEventListener("theme:cart:refresh", scheduleSync);
  document.addEventListener("theme:cart:loaded", scheduleSync);
  document.addEventListener("theme:cart:added", scheduleSync);
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) scheduleSync();
  });
})();
